<template>
  <form-item-facade class="select-item" :name="name" :errors="errors">
    <select-facade
      v-model="model"
      :disabled="disabled"
      :allow-clear="true"
      :id="name"
      :options="options"
      :placeholder="placeholder"
    />
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import FormItemFacade from '@/lib/ant-design-vue/components/FormItemFacade.vue';
  import SelectFacade from '@/lib/ant-design-vue/components/SelectFacade.vue';

  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Отключен ли выбор из списка
    disabled: {
      type: Boolean,
      default: false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // Список опций в списке (<option/>), которые можно выбрать.
    options: {
      default: [],
    },

    // Текст подсказки, что нужно выбрать в списке
    placeholder: {
      type: String,
      default: '',
    },
  });
</script>
